import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import IconAppStore from '../../assets/iconAppStore';
import IconGooglePlayStore from '../../assets/iconGooglePlayStore';
import IconCheckCircle from 'presentation/assets/iconCheckCircle';
import IconUserShieldCheckBig from '../../assets/iconUserShieldCheckBig';
import IconCarShieldBig from '../../assets/iconCarShieldBig';
import IconBagsGradientBig from '../../assets/iconBagsGradientBig';
import '../../assets/saas/molecules/_profit-loading.scss';
import { t } from 'i18next';
const ProfitLoading = () => {
    const features = [
        {
            title: t("title_profitloading_1"),
            subtitle: t("subtitle_profitloading_1"),
            description: t("description_profitloading_1"),
            icon: _jsx(IconUserShieldCheckBig, {})
        },
        {
            title: t("title_profitloading_2"),
            subtitle: t("subtitle_profitloading_2"),
            description: t("description_profitloading_2"),
            icon: _jsx(IconCarShieldBig, {})
        },
        {
            title: t("title_profitloading_3"),
            subtitle: t("subtitle_profitloading_3"),
            description: t("description_profitloading_3"),
            icon: _jsx(IconBagsGradientBig, {})
        },
    ];
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % features.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [features.length]);
    const currentFeature = features[currentIndex];
    return (_jsxs("div", { className: "profit-loading", children: [_jsxs("svg", { className: "border-svg", preserveAspectRatio: "none", children: [_jsx("rect", { pathLength: "1", className: "border-bg" }), _jsx("rect", { pathLength: "1", className: "border-line" })] }), _jsxs("div", { className: "profit-loading__container", children: [_jsxs("div", { className: "profit-loading__content", children: [_jsx("div", { className: "profit-loading__header", children: _jsx("h2", { className: "profit-loading__title", children: currentFeature.title }) }), _jsxs("div", { className: "profit-loading__feature", children: [_jsx("div", { className: "profit-loading__feature-header", children: _jsxs("h3", { className: "profit-loading__feature-title", children: [_jsx(IconCheckCircle, {}), " ", currentFeature.subtitle] }) }), _jsx("p", { className: "profit-loading__feature-description", children: currentFeature.description })] }), _jsxs("div", { className: "profit-loading__badges", children: [_jsx("div", { className: "profit-loading__badge profit-loading__badge--app-store", children: _jsx(IconAppStore, {}) }), _jsx("div", { className: "profit-loading__badge profit-loading__badge--google-play", children: _jsx(IconGooglePlayStore, {}) })] })] }), _jsx("div", { className: "profit-loading__content-icon", children: currentFeature.icon })] })] }));
};
export default ProfitLoading;
